// Athens' scripts.js sizes the open mobile menu as (viewport − header bottom + 70px),
// the 70px compensating its -60px overlap. nc-mobile-menu.css removes that overlap,
// so re-fit the menu to the viewport from where it actually starts. Uses offsetTop
// (layout position) rather than getBoundingClientRect, which is skewed mid-transition
// by the open animation's scale transform.
(function () {
  function fit() {
    var menu = document.querySelector('.mobile-menu-open .mobile-menu');
    if (!menu || !menu.offsetParent) return;
    var top = menu.offsetParent.getBoundingClientRect().top + menu.offsetTop;
    menu.style.maxHeight = Math.max(0, window.innerHeight - top) + 'px';
  }
  document.addEventListener('mobile-menu:open', fit);
  window.addEventListener('resize', fit);
}());
